import type { WordpressTaxonomy } from "@gik/core/models/wordpress/WordpressTaxonomy";
import type { UIComponent } from "@gik/core/types/UI";
import bemBlock from "@gik/core/utils/bemBlock";
import type { GiveTaxonomyType } from "@gik/shop/types/GiveTaxonomyType";
import { PageSection } from "@gik/ui-legacy/gik/PageSection";
import type React from "react";
import { useTranslation } from "react-i18next";
import translationKeys from "../../i18n/en";
import { SituationsGridWithNavWithData } from "../SituationsGridWithNav/SituationsGridWithNavWithData";

export type BySituationSectionProps = {
	title?: string;
	loadMoreButton?: boolean;
	taxonomyType: GiveTaxonomyType;
	parentTaxonomy: string;
	fallbackData?: WordpressTaxonomy[];
} & UIComponent;

export function BySituationSection({
	className,
	loadMoreButton,
	title,
	taxonomyType,
	parentTaxonomy,
	fallbackData,
}: BySituationSectionProps): React.ReactElement {
	const bem = bemBlock("by-situation-section");
	const { t } = useTranslation();

	return (
		<PageSection className={bem(null, null, className)}>
			<h2 className="gik-give-section-title">
				{title || t(translationKeys.bySituationTitle)}
			</h2>
			<SituationsGridWithNavWithData
				loadMoreButton={loadMoreButton}
				items={fallbackData}
				taxonomyType={taxonomyType}
				parentTaxonomy={parentTaxonomy}
			/>
		</PageSection>
	);
}
